import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { usePressFeedbackClick } from '../hooks/usePressFeedbackClick.js';

export type PressableProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Skip delayed press feedback (escape hatch). */
  skipPressFeedback?: boolean;
};

/**
 * Native `<button>` with held press chrome (`data-wp-pressing`). Click action runs sync.
 * Prefer this over raw `<button>` for DS clickables that are not `Button`/`IconButton`.
 */
export const Pressable = forwardRef<HTMLButtonElement, PressableProps>(function Pressable(
  { onClick, disabled, type = 'button', skipPressFeedback = false, ...rest },
  ref,
) {
  const { onClick: pressOnClick, pressing } = usePressFeedbackClick(onClick, {
    disabled: Boolean(disabled),
    submitForm: type === 'submit',
  });

  if (skipPressFeedback) {
    return <button ref={ref} type={type} disabled={disabled} onClick={onClick} {...rest} />;
  }

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={pressOnClick}
      data-wp-pressing={pressing ? '' : undefined}
      {...rest}
    />
  );
});
